import allIcon from '@images/renders/location_images/mapIcon/all.svg';
import allActiveIcon from '@images/renders/location_images/mapIcon/allActive.svg';
import beautyIcon from '@images/renders/location_images/mapIcon/beauty.svg';
import beautyActiveIcon from '@images/renders/location_images/mapIcon/beautyActive.svg';
import beautyBlackIcon from '@images/renders/location_images/mapIcon/beautyBlack.svg';
import cafeIcon from '@images/renders/location_images/mapIcon/cafe.svg';
import cafeActiveIcon from '@images/renders/location_images/mapIcon/cafeActive.svg';
import cafeBlackIcon from '@images/renders/location_images/mapIcon/cafeBlack.svg';
import educationIcon from '@images/renders/location_images/mapIcon/education.svg';
import educationActiveIcon from '@images/renders/location_images/mapIcon/educationActive.svg';
import educationBlackIcon from '@images/renders/location_images/mapIcon/educationBlack.svg';
import healthIcon from '@images/renders/location_images/mapIcon/health.svg';
import healthActiveIcon from '@images/renders/location_images/mapIcon/healthActive.svg';
import healthBlackIcon from '@images/renders/location_images/mapIcon/healthBlack.svg';
import parkIcon from '@images/renders/location_images/mapIcon/park.svg';
import parkActiveIcon from '@images/renders/location_images/mapIcon/parkActive.svg';
import parkBlackIcon from '@images/renders/location_images/mapIcon/parkBlack.svg';
import shopsIcon from '@images/renders/location_images/mapIcon/shopping.svg';
import shopsActiveIcon from '@images/renders/location_images/mapIcon/shoppingActive.svg';
import shopsBlackIcon from '@images/renders/location_images/mapIcon/shoppingBlack.svg';
import sportIcon from '@images/renders/location_images/mapIcon/sport.svg';
import sportActiveIcon from '@images/renders/location_images/mapIcon/sportActive.svg';
import sportBlackIcon from '@images/renders/location_images/mapIcon/sportBlack.svg';
import transportIcon from '@images/renders/location_images/mapIcon/transport.svg';
import transportActiveIcon from '@images/renders/location_images/mapIcon/transportActive.svg';
import transportBlackIcon from '@images/renders/location_images/mapIcon/transportBlack.svg';

export const mapPins = [
  {
    title: 'health',
    values: [
      {
        coordinates: [55.813786, 37.480315],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Центр оториноларингологии',
        category: 'health',
      },
      {
        coordinates: [55.803401, 37.488362],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Поликлиника № 115',
        category: 'health',
      },
      {
        coordinates: [55.816438, 37.506895],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Детская городская поликлиника № 133',
        category: 'health',
      },
      {
        coordinates: [55.818528, 37.502432],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Детская городская поликлиника № 15',
        category: 'health',
      },
      {
        coordinates: [55.803397, 37.496545],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Детская городская поликлиника № 39',
        category: 'health',
      },
      {
        coordinates: [55.806172, 37.455762],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Детская городская поликлиника № 58',
        category: 'health',
      },
      {
        coordinates: [55.819312, 37.466639],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Лечебно-реабилитационный центр',
        category: 'health',
      },
      {
        coordinates: [55.818411, 37.494882],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Городская поликлиника № 45',
        category: 'health',
      },
      {
        coordinates: [55.811946, 37.497552],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Стоматологическая поликлиника',
        category: 'health',
      },
      {
        coordinates: [55.803251, 37.487811],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Консультативно-диагностический центр',
        category: 'health',
      },
      {
        coordinates: [55.813211, 37.465571],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Поликлиническое отделение',
        category: 'health',
      },
      {
        coordinates: [55.805762, 37.45854],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Центр урологии',
        category: 'health',
      },
      {
        coordinates: [55.804885, 37.462563],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Городская поликлиника № 115',
        category: 'health',
      },
      {
        coordinates: [55.823224, 37.503108],
        icon: healthActiveIcon,
        blackIcon: healthBlackIcon,
        title: 'Городская онкологическая больница № 62',
        category: 'health',
      },
    ],
  },
  {
    title: 'sport',
    values: [
      {
        coordinates: [55.820359, 37.465776],
        icon: sportActiveIcon,
        blackIcon: sportBlackIcon,
        title: 'First&Only',
        category: 'sport',
      },
      {
        coordinates: [55.827158, 37.478488],
        icon: sportActiveIcon,
        blackIcon: sportBlackIcon,
        title: 'Marina Club',
        category: 'sport',
      },
      {
        coordinates: [55.82386, 37.496025],
        icon: sportActiveIcon,
        blackIcon: sportBlackIcon,
        title: 'World Class',
        category: 'sport',
      },
      {
        coordinates: [55.824109, 37.500058],
        icon: sportActiveIcon,
        blackIcon: sportBlackIcon,
        title: 'Spirit. Fitness',
        category: 'sport',
      },
      {
        coordinates: [55.80918, 37.512323],
        icon: sportActiveIcon,
        blackIcon: sportBlackIcon,
        title: 'Powerhouse Gym',
        category: 'sport',
      },
      {
        coordinates: [55.823922, 37.518016],
        icon: sportActiveIcon,
        blackIcon: sportBlackIcon,
        title: 'Gym-Gym',
        category: 'sport',
      },
      {
        coordinates: [55.801569, 37.470983],
        icon: sportActiveIcon,
        blackIcon: sportBlackIcon,
        title: 'EasyFitness',
        category: 'sport',
      },
      {
        coordinates: [55.809749, 37.464654],
        icon: sportActiveIcon,
        blackIcon: sportBlackIcon,
        title: 'DDX FITNESS',
        category: 'sport',
      },
      {
        coordinates: [55.809742, 37.459753],
        icon: sportActiveIcon,
        blackIcon: sportBlackIcon,
        title: 'Spirit. Fitness',
        category: 'sport',
      },
    ],
  },
  {
    title: 'shopping',
    values: [
      {
        coordinates: [55.809462, 37.463943],
        icon: shopsActiveIcon,
        blackIcon: shopsBlackIcon,
        title: 'Щука',
        category: 'shopping',
      },
      {
        coordinates: [55.799804, 37.482988],
        icon: shopsActiveIcon,
        blackIcon: shopsBlackIcon,
        title: '5 авеню',
        category: 'shopping',
      },
      {
        coordinates: [55.790491, 37.531373],
        icon: shopsActiveIcon,
        blackIcon: shopsBlackIcon,
        title: 'Авиапарк',
        category: 'shopping',
      },
      {
        coordinates: [55.801765, 37.531894],
        icon: shopsActiveIcon,
        blackIcon: shopsBlackIcon,
        title: 'Галерея Аэропорт',
        category: 'shopping',
      },
      {
        coordinates: [55.823492, 37.497697],
        icon: shopsActiveIcon,
        blackIcon: shopsBlackIcon,
        title: 'Метрополис',
        category: 'shopping',
      },
    ],
  },
  {
    title: 'education',
    values: [
      {
        coordinates: [55.813827, 37.45913],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 830',
        category: 'education',
      },
      {
        coordinates: [55.80705, 37.452319],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 1210',
        category: 'education',
      },
      {
        coordinates: [55.805177, 37.467442],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 1874',
        category: 'education',
      },
      {
        coordinates: [55.805044, 37.469902],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Курчатовская школа',
        category: 'education',
      },
      {
        coordinates: [55.804854, 37.471136],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Курчатовская школа',
        category: 'education',
      },
      {
        coordinates: [55.805348, 37.482519],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Курчатовская школа',
        category: 'education',
      },
      {
        coordinates: [55.805871, 37.5002],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 149',
        category: 'education',
      },
      {
        coordinates: [55.80923, 37.496151],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 1252',
        category: 'education',
      },
      {
        coordinates: [55.808412, 37.501395],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 1252',
        category: 'education',
      },
      {
        coordinates: [55.809914, 37.496431],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 1252',
        category: 'education',
      },
      {
        coordinates: [55.817583, 37.493226],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 2099',
        category: 'education',
      },
      {
        coordinates: [55.817439, 37.504923],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 717',
        category: 'education',
      },
      {
        coordinates: [55.819504, 37.500866],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 201',
        category: 'education',
      },
      {
        coordinates: [55.822026, 37.504244],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 90',
        category: 'education',
      },
      {
        coordinates: [55.819634, 37.511335],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 717',
        category: 'education',
      },
      {
        coordinates: [55.821427, 37.504318],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 201',
        category: 'education',
      },
      {
        coordinates: [55.815109, 37.462456],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Академическая гимназия, детский сад',
        category: 'education',
      },
      {
        coordinates: [55.813827, 37.45913],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 830',
        category: 'education',
      },
      {
        coordinates: [55.806848, 37.460873],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 1874',
        category: 'education',
      },
      {
        coordinates: [55.803331, 37.468407],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 1874',
        category: 'education',
      },
      {
        coordinates: [55.809649, 37.474002],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Курчатовская школа',
        category: 'education',
      },
      {
        coordinates: [55.80667, 37.482686],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Ювенес',
        category: 'education',
      },
      {
        coordinates: [55.809056, 37.474119],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Курчатовская школа',
        category: 'education',
      },
      {
        coordinates: [55.803833, 37.49011],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Мандарин',
        category: 'education',
      },
      {
        coordinates: [55.809096, 37.504266],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 149',
        category: 'education',
      },
      {
        coordinates: [55.809435, 37.497046],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 1252',
        category: 'education',
      },
      {
        coordinates: [55.810494, 37.493923],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Детские ясли № 642',
        category: 'education',
      },
      {
        coordinates: [55.813701, 37.493451],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 1252',
        category: 'education',
      },
      {
        coordinates: [55.817221, 37.487851],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Белый мишка',
        category: 'education',
      },
      {
        coordinates: [55.816234, 37.496326],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Лаборатория мехатроники и робототехники',
        category: 'education',
      },
      {
        coordinates: [55.816716, 37.491414],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 2099',
        category: 'education',
      },
      {
        coordinates: [55.817375, 37.489959],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 2099',
        category: 'education',
      },
      {
        coordinates: [55.816604, 37.491318],
        icon: educationActiveIcon,
        blackIcon: educationBlackIcon,
        title: 'Школа № 2099',
        category: 'education',
      },
    ],
  },
  {
    title: 'transport',
    values: [
      {
        coordinates: [55.812189, 37.486073],
        icon: transportActiveIcon,
        blackIcon: transportBlackIcon,
        title: 'МЦК Стрешнево',
        category: 'transport',
      },
      {
        coordinates: [55.815139, 37.487141],
        icon: transportActiveIcon,
        blackIcon: transportBlackIcon,
        title: 'МЦД-2 Стрешнево',
        category: 'transport',
      },
      {
        coordinates: [55.811673, 37.482591],
        icon: transportActiveIcon,
        blackIcon: transportBlackIcon,
        title: 'Автобусная остановка "Пехотная улица"',
        category: 'transport',
      },
    ],
  },
  {
    title: 'cafe',
    values: [
      {
        coordinates: [55.812753, 37.479723],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Кафетерий № 1',
        category: 'cafe',
      },
      {
        coordinates: [55.809997, 37.483283],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Д-кафе',
        category: 'cafe',
      },
      {
        coordinates: [55.809807, 37.476562],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Загородный',
        category: 'cafe',
      },
      {
        coordinates: [55.810668, 37.47636],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Я Самарканд',
        category: 'cafe',
      },
      {
        coordinates: [55.81661, 37.460146],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Бигсуши',
        category: 'cafe',
      },
      {
        coordinates: [55.809176, 37.463678],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Колбасофф',
        category: 'cafe',
      },
      {
        coordinates: [55.809388, 37.460437],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Якитория',
        category: 'cafe',
      },
      {
        coordinates: [55.80616, 37.461594],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Старый Батумъ',
        category: 'cafe',
      },
      {
        coordinates: [55.810055, 37.453163],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Пивотека 465',
        category: 'cafe',
      },
      {
        coordinates: [55.826628, 37.4447],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Kultura',
        category: 'cafe',
      },
      {
        coordinates: [55.816723, 37.500501],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Wildschwein',
        category: 'cafe',
      },
      {
        coordinates: [55.816566, 37.501779],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Bizone Lounge',
        category: 'cafe',
      },
      {
        coordinates: [55.823233, 37.495769],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Урюк',
        category: 'cafe',
      },
      {
        coordinates: [55.820501, 37.500883],
        icon: cafeActiveIcon,
        blackIcon: cafeBlackIcon,
        title: 'Ача-чача',
        category: 'cafe',
      },
    ],
  },
  {
    title: 'beauty',
    values: [
      {
        coordinates: [55.823846, 37.496418],
        icon: beautyActiveIcon,
        blackIcon: beautyBlackIcon,
        title: 'Wow Brow',
        category: 'beauty',
      },
      {
        coordinates: [55.823543, 37.500417],
        icon: beautyActiveIcon,
        blackIcon: beautyBlackIcon,
        title: 'Fashion place',
        category: 'beauty',
      },
      {
        coordinates: [55.820743, 37.508466],
        icon: beautyActiveIcon,
        blackIcon: beautyBlackIcon,
        title: 'Выбор Красоты',
        category: 'beauty',
      },
      {
        coordinates: [55.819765, 37.494346],
        icon: beautyActiveIcon,
        blackIcon: beautyBlackIcon,
        title: 'Салон красоты Lime',
        category: 'beauty',
      },
      {
        coordinates: [55.811207, 37.497939],
        icon: beautyActiveIcon,
        blackIcon: beautyBlackIcon,
        title: 'АртКреатив',
        category: 'beauty',
      },
      {
        coordinates: [55.808681, 37.498295],
        icon: beautyActiveIcon,
        blackIcon: beautyBlackIcon,
        title: 'Chi Studio',
        category: 'beauty',
      },
      {
        coordinates: [55.809202, 37.48349],
        icon: beautyActiveIcon,
        blackIcon: beautyBlackIcon,
        title: 'Салон красоты БонЖур',
        category: 'beauty',
      },
      {
        coordinates: [55.816226, 37.461584],
        icon: beautyActiveIcon,
        blackIcon: beautyBlackIcon,
        title: 'Robiar',
        category: 'beauty',
      },
      {
        coordinates: [55.809684, 37.463501],
        icon: beautyActiveIcon,
        blackIcon: beautyBlackIcon,
        title: 'Воображуля',
        category: 'beauty',
      },
      {
        coordinates: [55.807695, 37.461913],
        icon: beautyActiveIcon,
        blackIcon: beautyBlackIcon,
        title: 'In White',
        category: 'beauty',
      },
    ],
  },
  {
    title: 'park',
    values: [
      {
        coordinates: [55.829051, 37.428791],
        icon: parkActiveIcon,
        blackIcon: parkBlackIcon,
        title: 'Берег реки Сходня',
        category: 'park',
      },
      {
        coordinates: [55.810554, 37.479783],
        icon: parkActiveIcon,
        blackIcon: parkBlackIcon,
        title: 'Всехсвятская роща',
        category: 'park',
      },
      {
        coordinates: [55.822112, 37.476377],
        icon: parkActiveIcon,
        blackIcon: parkBlackIcon,
        title: 'Покровское-Стрешнево',
        category: 'park',
      },
      {
        coordinates: [55.830561, 37.484706],
        icon: parkActiveIcon,
        blackIcon: parkBlackIcon,
        title: 'Берёзовый парк',
        category: 'park',
      },
      {
        coordinates: [55.832759, 37.472286],
        icon: parkActiveIcon,
        blackIcon: parkBlackIcon,
        title: 'Парк Покровский берег',
        category: 'park',
      },
      {
        coordinates: [55.803607, 37.474193],
        icon: parkActiveIcon,
        blackIcon: parkBlackIcon,
        title: 'Щукинский парк',
        category: 'park',
      },
    ],
  },
];

export const mapFilters = [
  {
    id: 'all',
    title: 'Все объекты',
    icon: allIcon,
    iconActive: allActiveIcon,
  },
  {
    id: 'shopping',
    title: 'Магазины',
    icon: shopsIcon,
    iconActive: shopsActiveIcon,
  },
  {
    id: 'education',
    title: 'Образование',
    icon: educationIcon,
    iconActive: educationActiveIcon,
  },
  {
    id: 'health',
    title: 'Здоровье',
    icon: healthIcon,
    iconActive: healthActiveIcon,
  },
  {
    id: 'sport',
    title: 'Спорт',
    icon: sportIcon,
    iconActive: sportActiveIcon,
  },
  {
    id: 'transport',
    title: 'Транспорт',
    icon: transportIcon,
    iconActive: transportActiveIcon,
  },
  {
    id: 'cafe',
    title: 'Кафе и рестораны',
    icon: cafeIcon,
    iconActive: cafeActiveIcon,
  },
  {
    id: 'beauty',
    title: 'Салон красоты',
    icon: beautyIcon,
    iconActive: beautyActiveIcon,
  },
  {
    id: 'park',
    title: 'Парки и скверы',
    icon: parkIcon,
    iconActive: parkActiveIcon,
  },
];
